import Colors from "../../constants/Colors";
import EllipsisDecorationWhiteTiny from "../decorations/EllipsisDecorationWhiteTiny";
import { useTranslation } from 'react-i18next';

const ServicesCards = ({ color = Colors.white }) => {
  const { t } = useTranslation();
  const services = t("services");
  return (
    <div className="services-spacing" style={{ color: color }}>
      <p className='text-center pb-5 fs-48 fw-bold px-3'>{services.title}</p>

      <div className="bg-opacity row flex-column flex-xl-row d-flex align-items-center position-relative g-0">
        <ServicesDecorationleft />
        <div className="col">
          <p className="card-contact-services-title text-center fw-bold fs-36 mt-5 d-xl-none">
            {services.first.title}
          </p>
          <img
            className="img-services"
            src={`${process.env.PUBLIC_URL}/images/services/${services.first.imgURL}`}
            alt=""
          />
        </div>
        <div className="col">
          <div className="mx-3 mx-sm-5 my-5">
            <p className="card-contact-services-title text-center fw-bold fs-36 d-none d-xl-block">
              {services.first.title}
            </p>
            {
              services.first.content.map((item, index) => (
                <p key={index} className="card-text-services text-justify-responsive fw-regular fs-24">
                  {item}
                </p>
              ))
            }
            <Lab5GModal />
          </div>
        </div>
      </div>

      <div className="alt-bg-opacity row flex-column-reverse flex-xl-row d-flex align-items-center g-0">
        <div className="col" style={{ color: color }}>
          <div className="mx-3 mx-sm-5 my-5">
            <p className="card-contact-services-title text-center fw-bold fs-36 d-none d-xl-block">
              {services.second.title}
            </p>
            {
              services.second.content.map((item, index) => (
                <p key={index} className="card-text-services text-justify-responsive fw-regular fs-24">
                  {item}
                </p>
              ))
            }
            <UrbanModal />
          </div>
        </div>
        <div className="col">
          <div className="d-flex flex-column">

            <p className="card-contact-services-title text-center fw-bold fs-36 mt-5 d-xl-none">
              {services.second.title}
            </p>
            <img
              className="img-services ms-xl-auto me-xl-0"
              src={`${process.env.PUBLIC_URL}/images/services/${services.second.imgURL}`}
              alt=""
            />
          </div>
        </div>
      </div>

      <div className="row bg-opacity flex-column flex-xl-row d-flex align-items-center position-relative g-0">
        <ServicesDecorationRigth />
        <div className="col">
          <p className="card-contact-services-title text-center fw-bold fs-36 mt-5 d-xl-none">
            {services.third.title}
          </p>
          <img
            className="img-services"
            src={`${process.env.PUBLIC_URL}/images/services/${services.third.imgURL}`}
            alt=""
          />
        </div>
        <div className="col" style={{ color: color }}>
          <div className="mx-3 mx-sm-5 my-5">
            <p className="card-contact-services-title text-center fw-bold fs-36 d-none d-xl-block">
              {services.third.title}
            </p>
            {
              services.third.content.map((item, index) => (
                <p key={index} className="card-text-services text-justify-responsive fw-regular fs-24">
                  {item}
                </p>
              ))
            }
          </div>
        </div>
      </div>

      <div className="alt-bg-opacity row flex-column-reverse flex-xl-row d-flex align-items-center g-0">
        <div className="col" style={{ color: color }}>
          <div className="mx-3 mx-sm-5 my-5">
            <p className="card-contact-services-title text-center fw-bold fs-36 d-none d-xl-block">
              {services.fourth.title}
            </p>
            {
              services.fourth.content.map((item, index) => (
                <p key={index} className="card-text-services text-justify-responsive fw-regular fs-24">
                  {item}
                </p>
              ))
            }
          </div>
        </div>
        <div className="col">
          <div className="d-flex flex-column">
            <p className="card-contact-services-title text-center fw-bold fs-36 mt-5 d-xl-none">
              {services.fourth.title}
            </p>
            <img
              className="img-services ms-xl-auto me-xl-0"
              src={`${process.env.PUBLIC_URL}/images/services/${services.fourth.imgURL}`}
              alt=""
            />
          </div>
        </div>
      </div>
    </div>
  );
};

const Lab5GModal = () => {
  return (
    <>
      <div className="modal fade" id="infoModal" aria-hidden="true" aria-labelledby="infoModalLabel" tabIndex="-1">
        <div className="modal-dialog modal-fullscreen modal-dialog-centered">
          <div className="modal-content">
            <div className="modal-header">
              <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
            </div>
            <div className="modal-body">
              <LabInfo />
            </div>
          </div>
        </div>
      </div>
      <div className="modal fade" id="casesModal" aria-hidden="true" aria-labelledby="casesModalLabel" tabIndex="-1">
        <div className="modal-dialog modal-xl modal-dialog-centered">
          <div className="modal-content">
            <div className="modal-header">
              <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
            </div>
            <div className="modal-body">
              <UseCases />
            </div>
          </div>
        </div>
      </div>
      <div className="d-flex flex-column flex-sm-row justify-content-around mt-lg-5">
        <button className="rounded-pill mb-4 mb-sm-0 px-4 py-3 text-white fs-15 contact-button" data-bs-target="#infoModal" data-bs-toggle="modal">Sobre laboratorio 5G</button>
        <button className="rounded-pill mb-4 mb-sm-0 px-4 py-3 text-white fs-15 contact-button" data-bs-target="#casesModal" data-bs-toggle="modal">Ver casos de uso</button>
      </div>
    </>
  )
}

const LabInfo = ({ color = Colors.blue }) => {
  const { t } = useTranslation();

  const { title, text } = t('lab');
  return (
    <div>
      <p className='text-center blue-quantico pb-5 fs-48 fw-bold px-3'>{title}</p>
      <div className="d-flex flex-column">
        <div>
          <img
            style={{ width: '100%', height: "auto", objectFit: "cover" }}
            src={`${process.env.PUBLIC_URL}/images/services/lab-modal.png`}
            alt="lab-5g"
          />
        </div>
        <div style={{ color: color }}>
          <div className="mx-3 mx-sm-5 my-5">
            {
              text.map((item, index) => (
                <p key={index} className="card-text-services text-justify-responsive fw-regular fs-24">
                  {item}
                </p>
              ))
            }
          </div>
        </div>
      </div>
    </div>
  );
};

const UseCases = ({ color = Colors.blue }) => {
  const { t } = useTranslation();

  const SuccessCasesData = t('cases.list').slice(0, 3);
  return (
    <div className="px-lg-4">
      <h1 className="success-cases-title text-center fs-48 fw-semibold" style={{ color: color }} >
        {t('cases.title')}
      </h1>
      <div className="d-flex flex-column align-items-center">
        {
          SuccessCasesData.map((item, index) => {
            return (
              <div key={index} className="success-cases-card py-4 px-3 px-md-5 my-4 mx-3 d-flex flex-column bg-white">
                <p className="success-cases-description fw-bold mt-4">{item.title}</p>
                <img className="succes-cases-img py-4 mx-auto" alt='' src={(`${process.env.PUBLIC_URL}/images/cases/${item.imgURL}`)} />
                <div className="">
                  <p className="success-cases-description">{item.description}</p>
                  <ul>
                    {item.list.map((item, index) => {
                      return (
                        <li key={index} className="fs-14">
                          {item.text}
                        </li>
                      )
                    })}
                  </ul>
                </div>
              </div>
            );
          })}
      </div>
    </div>
  )
}

const UrbanModal = () => {
  return (
    <>
      <div className="modal fade" id="urbanModal" aria-hidden="true" aria-labelledby="urbanModalLabel" tabIndex="-1">
        <div className="modal-dialog modal-xl modal-dialog-centered">
          <div className="modal-content">
            <div className="modal-header">
              <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
            </div>
            <div className="modal-body">
              <UseCasesUrban />
            </div>
          </div>
        </div>
      </div>
      <div className="d-flex flex-column flex-sm-row justify-content-around mt-lg-5">
        <button className="rounded-pill mb-4 mb-sm-0 px-4 py-3 text-white fs-15 contact-button" data-bs-target="#urbanModal" data-bs-toggle="modal">Ver casos de uso</button>
      </div>
    </>
  )
}

const UseCasesUrban = ({ color = Colors.blue }) => {
  const { t } = useTranslation();

  const SuccessCasesData = t('cases.list').slice(3, 4);
  return (
    <div className="px-lg-4">
      <h1 className="success-cases-title text-center fs-48 fw-semibold" style={{ color: color }} >
        {t('cases.title')}
      </h1>
      <div className="d-flex flex-column align-items-center">
        {
          SuccessCasesData.map((item, index) => {
            return (
              <div key={index} className="success-cases-card py-4 px-3 px-md-5 my-4 mx-3 d-flex flex-column bg-white">
                <p className="success-cases-description fw-bold mt-4">{item.title}</p>
                <img className="succes-cases-img py-4 mx-auto" alt='' src={(`${process.env.PUBLIC_URL}/images/cases/${item.imgURL}`)} />
                <div className="">
                  <p className="success-cases-description">{item.description}</p>
                  <ul>
                    {item.list.map((item, index) => {
                      return (
                        <li key={index} className="fs-14">
                          {item.text}
                        </li>
                      )
                    })}
                  </ul>
                </div>
              </div>
            );
          })}
      </div>
    </div>
  )
}

const ServicesDecorationleft = () => {
  return (
    <div className="d-none d-xxl-block">
      <div
        className="position-absolute"
        style={{ bottom: "220px", left: "-150px", zIndex: "1" }}
      >
        <EllipsisDecorationWhiteTiny />
      </div>
    </div>
  );
};

const ServicesDecorationRigth = () => {
  return (
    <div className="d-none d-xxl-block">
      <div
        className="position-absolute"
        style={{ bottom: "150px", right: "200px", zIndex: "1" }}
      >
        <EllipsisDecorationWhiteTiny />
      </div>
    </div>
  );
};


export default ServicesCards;
